import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaWhatsapp, FaPhone } from "react-icons/fa";

const StickyContactIcons = () => {
  const handleCall = () => {
    window.location.href = "tel:+1-877-977-7656"; // Replace with actual phone number
  };

  const handleWhatsApp = () => {
    window.open("https://wa.me/+1-877-977-7656", "_blank"); // Replace with actual WhatsApp number
  };

  return (
    <div
      className="position-fixed bottom-0 end-0 mb-3 me-3 d-flex flex-column gap-2"
      style={{ zIndex: 1000 }}
    >
      <button
        className="btn btn-success rounded-circle p-3 shadow"
        onClick={handleWhatsApp}
      >
        <FaWhatsapp size={24} />
      </button>
      <button
        className="btn btn-primary rounded-circle p-3 shadow"
        onClick={handleCall}
      >
        <FaPhone size={24} />
      </button>
    </div>
  );
};

export default StickyContactIcons;
